/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Show_TimerInputs */

const en_live_caption_show_timer = /** @type {(inputs: Live_Caption_Show_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show session timer`)
};

const fr_live_caption_show_timer = /** @type {(inputs: Live_Caption_Show_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le minuteur de session`)
};

const de_live_caption_show_timer = /** @type {(inputs: Live_Caption_Show_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzungstimer anzeigen`)
};

const it_live_caption_show_timer = /** @type {(inputs: Live_Caption_Show_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra il timer della sessione`)
};

const ru_live_caption_show_timer = /** @type {(inputs: Live_Caption_Show_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать таймер сессии`)
};

const es_live_caption_show_timer = /** @type {(inputs: Live_Caption_Show_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar temporizador de sesión`)
};

const zh_cn2_live_caption_show_timer = /** @type {(inputs: Live_Caption_Show_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示会话计时器`)
};

const ja_live_caption_show_timer = /** @type {(inputs: Live_Caption_Show_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セッションタイマーを表示する`)
};

const hi_live_caption_show_timer = /** @type {(inputs: Live_Caption_Show_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेशन टाइमर दिखाएँ`)
};

const pt_pt2_live_caption_show_timer = /** @type {(inputs: Live_Caption_Show_TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar cronômetro da sessão`)
};

/**
* | output |
* | --- |
* | "Show session timer" |
*
* @param {Live_Caption_Show_TimerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_show_timer = /** @type {((inputs?: Live_Caption_Show_TimerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Show_TimerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_show_timer(inputs)
	if (locale === "de") return de_live_caption_show_timer(inputs)
	if (locale === "it") return it_live_caption_show_timer(inputs)
	if (locale === "ru") return ru_live_caption_show_timer(inputs)
	if (locale === "es") return es_live_caption_show_timer(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_show_timer(inputs)
	if (locale === "ja") return ja_live_caption_show_timer(inputs)
	if (locale === "hi") return hi_live_caption_show_timer(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_show_timer(inputs)
	return en_live_caption_show_timer(inputs)
});